import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { ItemToItemAddOnLinkContainerModel } from '../../../../../../models/aggregates/erp/add-ons-extended-warranty/item-to-item-add-on-link-container.model';



@Injectable({
  providedIn: 'root'
})
export class ItemToItemAddonLinkService extends BaseApiTemplateService<ItemToItemAddOnLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
  Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'item-to-item-addon-links/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'item-to-item-addon-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'item-to-item-addon-links/backoffice-ep';
    this.httpClient = http;
  }
}
